<template>
    <nav id="navigation-overlay" :class="{ open: menuOpen }">
        <x-container fluid py-0 app-width>
            <x-layout align-center>
                <x-flex xs12>
                    <ul>
                        <li @click="closeNavigation()">
                            <router-link :to="dashboardLink">Dashboard</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsBroker">
                            <router-link to="/agent/policy/new">Create policy</router-link>
                        </li>
                        <li @click="closeNavigation()">
                            <router-link :to="companyManagerLink">Company manager</router-link>
                        </li>
                        <li @click="closeNavigation()">
                            <router-link to="/basic/tasks/dashboard">Task manager</router-link>
                        </li>
                        <li @click="closeNavigation()">
                            <router-link :to="reportsLink">Reports</router-link>
                        </li>
                        <li @click="closeNavigation()">
                            <router-link :to="analyticsLink">Analytics</router-link>
                        </li>
                        <li @click="logout">
                            <router-link to="/">Logout</router-link>
                        </li>
                    </ul>
                </x-flex>
            </x-layout>
        </x-container>
    </nav>
</template>

<script>
    export default {
        props: ['menuOpen'],
        computed: {
            dashboardLink() {
                return this.userIsInsured ? '/insured/dashboard/' : '/agent/dashboard/';
            },
            companyManagerLink() {
                return this.userIsInsured ? '/insured/company-manager' : '/agent/company-manager';
            },
            userIsInsured() {
                return this.$root.user.company && this.$root.user.company.company_type === 'insured';
            },
            userIsBroker() {
                return this.$root.user.company && this.$root.user.company.company_type === 'broker';
            },
            reportsLink() {
                return this.userIsInsured ? '/insured/reports' : '/agent/reports';
            },
            analyticsLink() {
                return this.userIsInsured ? '/insured/analytics' : '/agent/analytics';
            },
        },
        methods: {
            logout() {
                this.$hyperionAuth.logout();
                this.$router.push({ name: 'login' });

            },
            closeNavigation() {
                this.$emit('closeNav');
            }
        }
    }
</script>

<style lang="scss" scoped>
#navigation-overlay {
    overflow-x: auto;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.5s, visibility 0s 0.5s;
    z-index: 4;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: $color-primary;

    ul {
        list-style: none;
        padding: 0;
        display: inline-block;
        position: relative;
        text-align: left;
        margin: rem(156px 0 0 220px);

        li {
            display: block;
            line-height: 1.5em;
            text-shadow: none;
            color: #fff;
            margin-bottom: rem(50px);
            transition: all 0.35s ease-out;
            opacity: 0;
            transform: scale(0.75) translateY(-24px);

            a {
                display: block;
                color: #fff;
                transition: color 0.2s;
                font-family: $font-title;
                font-size: rem(42px);

                &:hover,
                &:focus {
                    color: white;
                }
            }

            @for $i from 1 through 10 {
                &:nth-child(#{$i}) {
                    transition-delay: $i * 0.05s;
                }
            }
        }
    }

    &.open {
        opacity: 1;
        visibility: visible;
        transition: none;

        ul {
            li {
                opacity: 1;
                transform: scale(1) translateY(0);
            }
        }
    }

    @media (min-width: 768px) {
        ul {
            li {
                font-size: 2.875em;
                line-height: 1.25em;
            }
        }
    }
}
</style>
